import { useLocation, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { makeRequest } from '@/services/makeRequest';
import {
	getSeoContent,
	setSeoContent,
	setSeoDescription,
	setSeoTitle,
} from '@/stores/slices/titleSlice';
import { useDispatch, useSelector } from 'react-redux';
import baseUrl from '@/services/apiConfig';
import useLadyService from '@/services/LadyService';

const SEOBlock = ({}) => {
	const location = useLocation();
	const pageSlug = location?.pathname
		.replace(baseUrl, '')
		.replace(/^\/(en|cz|ru)/, '');
	const dispatch = useDispatch();
	const seoContent = useSelector(getSeoContent);

	const { lang } = useLadyService();

	const isJsdom =
		typeof window !== 'undefined' &&
		window.navigator.userAgent.includes('jsdom');

	const [isReady, setIsReady] = useState(false);

	const fetchData = async () => {
		const route = `static${pageSlug !== '/' && pageSlug !== '/czechia' ? pageSlug : '/home'}`;
		const method = 'GET';

		makeRequest({ route, method })
			.then((response) => {
				if (response) {
					console.log(`=> SEO TITLE: `, response?.seo_title);
					dispatch(setSeoContent(response?.content));
					dispatch(setSeoTitle(response?.seo_title));
					dispatch(setSeoDescription(response?.seo_description));
				} else {
					throw new Error('no seo response');
				}
			})
			.catch((err) => {
				console.error(err);
				dispatch(setSeoTitle(false));
				dispatch(setSeoDescription(false));
				dispatch(setSeoContent(false));
			});
	};

	useEffect(() => {
		if (!isReady) return;
		fetchData();
	}, [location, isReady]);

	// Ждём стабилизации роута (pathname не меняется 100мс)
	useEffect(() => {
		const timeoutId = setTimeout(() => {
			setIsReady(true);
		}, 100);

		return () => clearTimeout(timeoutId);
	}, [location.pathname]);

	return (
		<>
			{seoContent && (
				<div
					className="container w-100 gap-0"
					dangerouslySetInnerHTML={{ __html: seoContent }}
				></div>
			)}
			{!isJsdom && (
				<div className="container w-100 gap-0">
					{(location.pathname === `/${lang}/czechia` ||
						location.pathname === '/') && (
						<p>
							<a
								href={`/${lang}/links`}
								style={{ marginRight: '4px' }}
							>
								{lang === 'cz' && <>Naši partneři.</>}
								{lang === 'ru' && <>Наши партнёры.</>}
								{lang === 'en' && <>Our partners.&nbsp;</>}
							</a>

							{lang === 'cz' && (
								<>
									<a
										href="https://ceskeholky.cz"
										target="_blank"
									>
										České holky
									</a>{' '}
									– erotická inzerce v České republice.
								</>
							)}
						</p>
					)}
				</div>
			)}
		</>
	);
};

export default SEOBlock;
